/**
 * ============================================================
 * dealsSlice.ts — Estado de Deals (Negocios/Leads) do CRM
 * ============================================================
 *
 * Responsabilidade: só o lead selecionado (painel/modal). A lista de leads
 *   e as mutações vivem no React Query (`useDeals`, `useDealsList`,
 *   `useLeadMutations`) — uma fonte de verdade, desde 15/09/2026.
 *
 * ============================================================
 */

import type { StateCreator } from 'zustand';
import type { Deal } from '../types';

// ── Interface do Slice ──
// Os leads em si vivem no React Query (`useDeals` / `useDealsList`); a store
// só guarda o lead selecionado para painel/modal. As ações de CRUD ficaram em
// `useLeadMutations` (escrevem no cache do React Query) desde 15/09/2026.
export interface DealsSlice {
  selectedDeal: Deal | null;
  setSelectedDeal: (deal: Deal | null) => void;
}

export const createDealsSlice: StateCreator<DealsSlice, [], [], DealsSlice> = (set) => ({
  selectedDeal: null,
  setSelectedDeal: (deal) => set({ selectedDeal: deal }),
});
